import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  InputAdornment,
  TextField,
  Typography,
  Grid,
  Alert,
  CircularProgress,
} from "@mui/material";
import { PushPin, LocationOn, Save, ArrowBack } from "@mui/icons-material";
import MapaDireccionEnv from "../../../clientesEnvasado/fichaCliente/direcciones/MapaDireccionEnv";
import Notify from "../../../../Notify";
import { putData } from "../../../../../services/library";

function AgregarCoordenadasEnv({ open, onClose, direccionSeleccionada }) {
  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "success",
  });

  const [formData, setFormData] = useState(direccionSeleccionada);
  const [loading, setLoading] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);

  useEffect(() => {
    setFormData(direccionSeleccionada);
    setHasChanges(false);
  }, [direccionSeleccionada]);

  const handleSaveCoordinates = async (e) => {
    if (e) e.preventDefault();

    if (!formData.latitud || !formData.longitud) {
      setNotificacion({
        open: true,
        mensaje: "Debe ingresar tanto latitud como longitud",
        severity: "error",
      });
      return;
    }

    setLoading(true);

    try {
      await putData(
        e,
        `/envasado_direcciones_entrega/${formData.id}`,
        {
          latitud: parseFloat(formData.latitud),
          longitud: parseFloat(formData.longitud),
        },
        setNotificacion
      );

      setHasChanges(false);
      setTimeout(() => {
        onClose(true);
      }, 1500);
    } catch (error) {
      setNotificacion({
        open: true,
        mensaje: "Error al guardar las coordenadas",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value === "" ? null : value,
    }));
    setHasChanges(true);
  };

  const handleMapDataChange = (newData) => {
    setFormData(newData);
    setHasChanges(true);
  };

  const handleClose = () => {
    if (
      hasChanges &&
      !window.confirm(
        "Tiene cambios sin guardar. ¿Está seguro de que desea salir?"
      )
    ) {
      return;
    }
    onClose(false);
  };

  return (
    <>
      <Notify
        mensaje={notificacion.mensaje}
        open={notificacion.open}
        handleClose={() =>
          setNotificacion((prev) => ({ ...prev, open: false }))
        }
        severity={notificacion.severity}
      />

      <Dialog
        fullWidth
        open={open}
        onClose={handleClose}
        maxWidth="sm"
        PaperProps={{
          sx: {
            maxHeight: "95vh",
            height: "auto",
            // Asegurar que el z-index no sea demasiado alto
            zIndex: 1300,
          },
        }}
      >
        <DialogTitle
          sx={{
            bgcolor: "#1F618D",
            color: "white",
            py: 1.5,
            "& .MuiTypography-root": { fontSize: "1.1rem" },
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <LocationOn />
            <Typography variant="h6">Agregar Coordenadas</Typography>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ p: 2 }}>
          {/* Información básica */}
          <Alert severity="info" sx={{ mb: 2, fontSize: "0.8rem" }}>
            {direccionSeleccionada?.direccion_entrega ||
              "Seleccione la ubicación en el mapa"}
          </Alert>

          {/* Mapa con contenedor de altura fija */}
          <Box sx={{ mb: 2 }}>
            <Box
              sx={{
                height: 250,
                border: "1px solid #ddd",
                borderRadius: 1,
                overflow: "hidden",
                position: "relative",
                zIndex: 1, // Bajo z-index para el contenedor del mapa
              }}
            >
              <MapaDireccionEnv
                setDatosDir={handleMapDataChange}
                datosDir={formData}
                height="250px"
              />
            </Box>
          </Box>

          {/* Campos de coordenadas */}
          <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={6}>
              <TextField
                fullWidth
                size="small"
                label="Latitud"
                name="latitud"
                value={formData?.latitud || ""}
                onChange={handleInputChange}
                placeholder="-34.603722"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PushPin fontSize="small" />
                    </InputAdornment>
                  ),
                }}
                focused
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                size="small"
                label="Longitud"
                name="longitud"
                value={formData?.longitud || ""}
                onChange={handleInputChange}
                placeholder="-58.381592"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PushPin fontSize="small" />
                    </InputAdornment>
                  ),
                }}
                focused
              />
            </Grid>
          </Grid>

          {/* Estado actual */}
          {(formData?.latitud || formData?.longitud) && (
            <Alert severity="success" sx={{ mb: 2, fontSize: "0.8rem" }}>
              Coordenadas: Lat {formData.latitud || "-"} | Long{" "}
              {formData.longitud || "-"}
            </Alert>
          )}

          {/* Botones */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              gap: 1,
            }}
          >
            <Button
              // startIcon={<ArrowBack />}
              onClick={handleClose}
              variant="outlined"
              color="error"
              size="small"
            >
              Volver
            </Button>
            <Button
              // startIcon={loading ? <CircularProgress size={16} /> : <Save />}
              onClick={handleSaveCoordinates}
              variant="contained"
              color="success"
              disabled={loading || !hasChanges}
              size="small"
              sx={{ minWidth: 140 }}
            >
              {loading ? "Guardando..." : "Guardar"}
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default AgregarCoordenadasEnv;
